import { render } from "./SelectedPatientNIM.vue?vue&type=template&id=f6570e22&scoped=true"
import script from "./SelectedPatientNIM.vue?vue&type=script&lang=js"
export * from "./SelectedPatientNIM.vue?vue&type=script&lang=js"

import "./SelectedPatientNIM.vue?vue&type=style&index=0&id=f6570e22&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6570e22"]])

export default __exports__